import {
  post as apiPost,
  get as apiGet,
  put as apiPut,
  TYPE_BROOKLYN_JSON,
  TYPE_BROOKLYN,
} from 'api-client'
import _isEmpty from 'lodash/isEmpty'
import _assign from 'lodash/assign'
import _get from 'lodash/get'
import { Map } from 'immutable'
import { URL_GIFT as BASE_GIFT_URL } from 'services/url/constants'
import pathToRegexp from 'path-to-regexp'

export const GIFT_MOBILE_BREAKPOINT = 944
export const GIFT_READY_STATE = {
  NOT_READY: 'NOT_READY',
  CHILD_ACCOUNT: 'CHILD_ACCOUNT',
  CAN_PURCHASE: 'CAN_PURCHASE',
  CANNOT_PURCHASE: 'CANNOT_PURCHASE',
}

export const GIFT_SUBSCRIPTION_STATE = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
  PENDING: 'Pending',
}

/**
 * @typedef {Object} RouteDetails
 * @property {String} encodedSku
 * @property {String} [subRoute]
 *
 * @param {String} currentPath
 * @returns {RouteDetails}
 */
export function getRouteDetails (currentPath) {
  const pathPattern = `${BASE_GIFT_URL}/:sku/:page?`
  const regExp = pathToRegexp(pathPattern)
  const result = regExp.exec(currentPath)
  return {
    encodedSku: result && result[1],
    subRoute: result && result[2],
  }
}

export async function createOrder (order, auth) {
  try {
    const res = await apiPost('v1/gift', order, {
      auth,
    }, TYPE_BROOKLYN_JSON)
    return _get(res, 'body', {})
  } catch (err) {
    return {
      error: true,
      success: false,
      errorCode: 'GENERIC_ERROR',
    }
  }
}

export async function get (token) {
  try {
    const res = await apiGet('v1/gift', { token }, {}, TYPE_BROOKLYN_JSON)
    const statusCode = _get(res, 'status')
    const body = _get(res, 'body', {})
    return _assign({}, body, { statusCode })
  } catch (err) {
    const statusCode = _get(err, 'status', 500)
    return { statusCode, token }
  }
}

export async function redeem ({ token, auth = Map(), user = {} }) {
  let data = {}
  if (!_isEmpty(user)) {
    const emailOptIn = _get(user, 'emailOptIn')
    // eslint-disable-next-line no-param-reassign
    delete user.emailOptIn
    data = { user, emailOptIn }
  }
  try {
    const res = await apiPut(`v1/gift/${token}`, data, {
      auth,
    }, TYPE_BROOKLYN_JSON)
    const body = _get(res, 'body', {})
    return body
  } catch (err) {
    return {
      errorCode: 'ERROR_REDEEMING_GIFT',
      errorDisplayCode: 211,
      success: false,
    }
  }
}

export async function getEligible (auth) {
  try {
    const res = await apiGet('v1/gift/subscribe-reminder', {}, { auth }, TYPE_BROOKLYN)
    const body = _get(res, 'body', {})
    return body
  } catch (err) {
    const statusCode = _get(err, 'status', 500)
    return { statusCode }
  }
}
